import type { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  subtitle?: string
  /** 可选小标签，默认不使用 */
  eyebrow?: string
  /** 标题下方元信息（更新时间、环境等） */
  meta?: ReactNode
  /** 标题区右侧附加内容 */
  extra?: ReactNode
  actions?: ReactNode
  className?: string
}

/**
 * 页面顶部工具条：左侧标题 + 副标题，右侧操作按钮组。
 * title 20px/700，subtitle 13px muted；放在 PageContainer 最顶部，mb-5。
 */
export default function PageHeader({
  title,
  subtitle,
  eyebrow,
  meta,
  extra,
  actions,
  className = '',
}: PageHeaderProps) {
  return (
    <div className={`flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between mb-5 ${className}`}>
      <div className="min-w-0 flex-1">
        {eyebrow ? (
          <p className="text-[11px] font-semibold uppercase tracking-[0.06em] text-[var(--console-text-subtle)] mb-1">
            {eyebrow}
          </p>
        ) : null}
        <div className="flex flex-col sm:flex-row sm:items-start sm:gap-4">
          <div className="min-w-0 flex-1">
            <h1 className="text-[20px] font-bold text-[var(--console-text)] tracking-[-0.01em] leading-tight">
              {title}
            </h1>
            {subtitle ? (
              <p className="text-[13px] text-[var(--console-text-muted)] mt-0.5 max-w-[65ch]">
                {subtitle}
              </p>
            ) : null}
            {meta ? <div className="mt-1.5 text-[12px] text-[var(--console-text-subtle)]">{meta}</div> : null}
          </div>
          {extra ? <div className="mt-2 sm:mt-0 flex-shrink-0">{extra}</div> : null}
        </div>
      </div>
      {actions ? (
        <div className="w-full sm:w-auto flex flex-wrap items-center gap-2 justify-start sm:justify-end flex-shrink-0">
          {actions}
        </div>
      ) : null}
    </div>
  )
}
